import React from 'react';
import { Button } from "@/components/ui/button";
import { ChevronDown, MessageCircle, Lightbulb } from "lucide-react";

interface GradientResponseIndicatorProps {
  message: string;
  onExpandRequest: () => void;
  className?: string;
}

export const GradientResponseIndicator = ({ 
  message, 
  onExpandRequest, 
  className = "" 
}: GradientResponseIndicatorProps) => {
  // Check if the message contains depth signals
  const depthSignals = [
    "I can elaborate",
    "Would you like me to",
    "I can go deeper",
    "I can provide more detail",
    "Would you like more information",
    "I can expand on",
    "Let me know if you'd like",
    "I can share more about"
  ];

  const hasDepthSignal = depthSignals.some(signal => 
    message.toLowerCase().includes(signal.toLowerCase())
  );

  if (!hasDepthSignal) return null;

  // Extract the specific topic they can expand on
  const expandMatch = message.match(/I can (elaborate|go deeper|expand) on ([^.!?]+)/i);
  const expandTopic = expandMatch ? expandMatch[2] : "this topic";

  return (
    <div className={`mt-3 p-3 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-950/20 dark:to-purple-950/20 rounded-lg border border-blue-200 dark:border-blue-800 ${className}`}>
      <div className="flex items-center gap-2 mb-2">
        <Lightbulb className="h-4 w-4 text-blue-600 dark:text-blue-400" />
        <span className="text-sm font-medium text-blue-800 dark:text-blue-200">
          More depth available
        </span>
      </div>
      
      <p className="text-sm text-blue-700 dark:text-blue-300 mb-3">
        I can provide more detailed information about {expandTopic.trim()}
      </p>
      
      <Button 
        onClick={onExpandRequest}
        size="sm"
        variant="outline"
        className="border-blue-300 hover:bg-blue-100 dark:border-blue-700 dark:hover:bg-blue-900/20 text-blue-700 dark:text-blue-300"
      >
        <ChevronDown className="h-3 w-3 mr-1" />
        Tell me more
      </Button>
    </div>
  );
}; 